import UserApi from '../api/user-api.service';
import {IUserDetailsStateParams} from '../hydromet/userManagement/details/userDetails.controller';

export default function userPermissionsFactory(userApi: UserApi, $stateParams: IUserDetailsStateParams) {
  return {
    restrict: 'A',
    scope: {
      userPermissions: '<'
    },
    link: function (scope:ng.IScope, el:ng.IAugmentedJQuery,
                    attrs:ng.IAttributes) {
      	scope.$watch(attrs['userPermissions'], function (visible:any) {
          let cachedDisplayValue = el.css('display');
          
      		el.css('display', 'none');

	      	userApi.getCurrentUser()
	      		.then(data => {
              scope['userPermissions'].forEach((permission: string) => {
                if (permission === data.role || 
                  permission === 'current_user' && 
                  (parseInt($stateParams.id, 10) === data.id || $stateParams.id === "me")
                ) {
                  el.css('display', cachedDisplayValue);
                  return;
                }
              });
	      			
	      		})
      	});
    }
  }
}

userPermissionsFactory.$inject = ['userApi', '$stateParams'];


/** WEBPACK FOOTER **
 ** ./app/utils/user-permissions.directive.ts
 **/